import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Icon from '../Icon';

import classes from './styles.module.css';
import { FormattedMessage } from 'react-intl';

class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.toggleState = this.toggleState.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, false);

        this.setState({
            isOpened: false,
        });
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        document.addEventListener('click', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, false);
    }

    handleClickOutside(e) {
        const node = ReactDOM.findDOMNode(this);

        if (!node || !node.contains(e.target)) {
            this.setState({
                isOpened: false,
            });
        }
    }

    toggleState() {
        this.setState({ isOpened: !this.state.isOpened });
    }

    render() {
        // Пропсы читаются при каждом рендере, а не запоминаются в
        // конструкторе: заголовок бывает живым (например, с числом
        // непрочитанных сообщений), и запомненный однажды он больше
        // никогда не обновлялся.
        const { title, icon, isHeader, isFullWidth, hideArrow } = this.props;
        const useLocale = typeof this.props.useLocale === 'undefined' ? true : this.props.useLocale;
        const headerStyle = isHeader ? { color: 'hsla(0,0%,100%,.8)', lineHeight: '48px' } : undefined;

        return (
            <li>
                <div
                    onClick={this.toggleState}
                    style={headerStyle}
                    className={this.state.isOpened ? classes.Link + ' ' + classes.Active : classes.Link}
                >
                    <Icon className={classes.IconLeft} icon={icon} size={'16px'} />

                    {useLocale
                        ? title && <FormattedMessage id={title} defaultMessage={title} />
                        : title}
                    {!hideArrow && <Icon className={classes.IconRight} icon="cheveron-down" size={'18px'} />}
                </div>

                {this.state.isOpened && (
                    <ul datatype="submenu" className={isFullWidth ? classes.FullSubmenu : classes.Submenu}>
                        {this.props.children}
                    </ul>
                )}
            </li>
        );
    }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/Components/Utils/Dropdown/index.js